var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.countryFlag)?_c('img',{attrs:{"alt":"country-flag","src":_vm.countryFlag,"height":"24"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }